import React, { useState } from "react";
import Hero from "venuescanner-js/react/components/VirtualEvents/components/Hero";
import Categories from "venuescanner-js/react/components/VirtualEvents/components/Categories";
import Faqs from "venuescanner-js/react/components/VirtualEvents/components/Faqs";
import Reviews from "venuescanner-js/react/components/VirtualEvents/components/Reviews";
import MoreInfo from "venuescanner-js/react/components/VirtualEvents/components/MoreInfo";
import Form from "venuescanner-js/react/components/VirtualEvents/components/Form";

const Index = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  return (
    <div>
      <Hero setIsFormOpen={setIsFormOpen} />
      <Categories setIsFormOpen={setIsFormOpen} />
      <Faqs />
      <Reviews />
      <MoreInfo setIsFormOpen={setIsFormOpen} />
      {/* <Form /> */}
      {isFormOpen && <Form setIsFormOpen={setIsFormOpen} />}
    </div>
  );
};

export default Index;
